import { useLocation } from 'react-router-dom';
import { usePlaybackStore } from '@/stores/playback';
import { resolvePageBadgeInfo, shouldShowPageBadge } from '@/lib/page-badge';

export function PageBuildBadge() {
  const location = useLocation();
  const viewMode = usePlaybackStore((s) => s.viewMode);
  const context = {
    pathname: location.pathname,
    search: location.search,
    hostname: window.location.hostname,
    isDev: import.meta.env.DEV,
    isE2E: import.meta.env.VITE_DISABLE_MSW === 'true',
    debugFlag: import.meta.env.VITE_SHOW_PAGE_BADGE,
    viewMode,
  };

  if (!shouldShowPageBadge(context)) return null;

  const { pageName, versionLabel } = resolvePageBadgeInfo(context);
  // #1269 F0: on mobile viewer pages the badge sits above the bottom controls
  // at a lower stacking level, away from the header's boat-selector row.
  // Desktop keeps the established top-right screenshot marker.
  // Every other page keeps the bottom-left corner.
  const isViewerPage = pageName.includes('Viewer');

  return (
    <div
      className={`rr-page-build-badge pointer-events-none fixed rounded border px-2 py-1 text-[10px] font-medium shadow-sm backdrop-blur ${
        isViewerPage
          ? 'bottom-[5.5rem] left-2 z-20 md:bottom-auto md:left-auto md:right-2 md:top-2 md:z-[80]'
          : 'bottom-2 left-2 z-[80]'
      }`}
      data-testid="page-build-badge"
      aria-label={`${pageName} ${versionLabel}`}
    >
      <span>{pageName}</span>
      <span className="rr-page-build-badge-separator mx-1">·</span>
      <span className="rr-page-build-badge-version font-mono">{versionLabel}</span>
    </div>
  );
}
